import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Star, Loader2, Copy, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReviewReplies = () => {
  const [form, setForm] = useState({ author: "", stars: 5, review: "" });
  const [reply, setReply] = useState("");
  const [busy, setBusy] = useState(false);

  const draft = async () => {
    setBusy(true);
    try {
      setReply((await axios.post(`${API}/admin/reviews/reply-draft`, form)).data.reply);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Collez le texte de l'avis");
    }
    setBusy(false);
  };

  const copy = () => navigator.clipboard.writeText(reply).then(() => toast.success("Réponse copiée"));

  return (
    <Card className="border-0 shadow-sm" data-testid="review-replies-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Star className="w-5 h-5 text-[#F97316]" /> Réponses aux avis Google</CardTitle>
        <CardDescription>Collez un avis, l'IA rédige une réponse à copier dans votre fiche Google.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex flex-wrap items-center gap-3">
          <Input className="max-w-xs" placeholder="Prénom de l'auteur (facultatif)" value={form.author} onChange={(e) => setForm({ ...form, author: e.target.value })} data-testid="review-author-input" />
          <div className="flex gap-1" data-testid="review-stars">
            {[1, 2, 3, 4, 5].map((n) => (
              <button key={n} type="button" onClick={() => setForm({ ...form, stars: n })} data-testid={`review-star-${n}`} aria-label={`${n} étoiles`}>
                <Star className={`w-6 h-6 ${n <= form.stars ? "fill-[#F97316] text-[#F97316]" : "text-slate-300"}`} />
              </button>
            ))}
          </div>
        </div>
        <Textarea rows={4} placeholder="Texte de l'avis du client" value={form.review} onChange={(e) => setForm({ ...form, review: e.target.value })} data-testid="review-text-input" />
        <Button onClick={draft} disabled={busy || form.review.trim().length < 2} className="bg-[#102692] text-white" data-testid="review-draft-btn">
          {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Sparkles className="w-4 h-4 mr-1" />} Rédiger la réponse
        </Button>
        {reply && (
          <div className="space-y-2">
            <Textarea rows={5} value={reply} onChange={(e) => setReply(e.target.value)} data-testid="review-reply-output" />
            <Button variant="outline" onClick={copy} data-testid="review-copy-btn"><Copy className="w-4 h-4 mr-1" /> Copier</Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
